<template>
	<div class="login">
		<div class="logo">
			<img src="/img/livelines_logo.png" />
		</div>
		<div class="center">
			<p>Your access to this application has not yet been authorised. Please contact Livelines for assistance.</p>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	
	name: "UnauthorisedPage"
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.center {
	text-align: center
}

p {
	margin: 15px 0 30px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.7;
    color: #bdbac2;
}

.logo {
	text-align: center;
}

.logo img {
	width: 300px;
	margin-bottom: 15px;
}

</style>
